import React from 'react';

import { Header as BokehHeader, rem } from '@vimeo/bokeh';

import { defaultTemplateProps } from '../../utils/interface';
import { getModalHeader, getModalSubheader } from '../../utils/utils';
import DismissIcon from '../common/DismissIcon';
import { HeaderContainer, SubHeader } from './styles';

interface Props {
  modalConfig?: defaultTemplateProps;
  onClose: VoidFunction;
  userName?: string;
}

const Header = (props: Props) => {
  const modalSubHeader = getModalSubheader(props.modalConfig?.subHeaderText);
  const overrideHeaderText = props.modalConfig?.headerText;
  const showHeader = overrideHeaderText !== '' && overrideHeaderText !== null;

  return (
    <HeaderContainer>
      {showHeader && (
        <BokehHeader size="lg" data-testid="upsell-header-text">
          {getModalHeader(props.modalConfig?.headerText)}
        </BokehHeader>
      )}
      {modalSubHeader ? (
        <SubHeader data-testid="upsell-subheader-text">{modalSubHeader}</SubHeader>
      ) : null}
      <DismissIcon margin={rem(8)} onClose={props.onClose} />
    </HeaderContainer>
  );
};

export default Header;
